import { FC } from "react";

import Modal from "../../../../components/Modal/Modal";
import Button from "../../../../components/Button/Button";
import InputField from "../../../../components/InputField/InputField";
import { getDisplayName } from "../../utils";
import { IRenameClientModalProps } from "./types";

import styles from "./RenameClientModal.module.css";

const cls = (el?: string) => styles[el ? `rename-modal__${el}` : "rename-modal"];

const RenameClientModal: FC<IRenameClientModalProps> = ({
  client,
  label,
  onLabelChange,
  onConfirm,
  onClose,
  loading,
  error,
}) => {
  if (!client) return null;

  const isValid = Boolean(label.trim());

  return (
    <Modal isOpen={!!client} onClose={onClose}>
      <div className={cls()}>
        <h3 className={cls("title")}>Rename Client</h3>
        <p className={cls("text")}>
          Set a display name for <strong>{getDisplayName(client)}</strong>.
        </p>
        <div className={cls("field")}>
          <InputField
            label="Client name"
            value={label}
            onChange={(e) => onLabelChange(e.target.value)}
            placeholder="Client name"
            disabled={loading}
            autoFocus
          />
        </div>
        {error && <p className={cls("error")}>{error}</p>}
        <div className={cls("actions")}>
          <Button
            label="Cancel"
            typeStyle="outline"
            size="md"
            onClick={onClose}
            type="button"
            disabled={loading}
          />
          <Button
            label={loading ? "Saving…" : "Save"}
            typeStyle="fill-dark"
            size="md"
            onClick={onConfirm}
            type="button"
            disabled={loading || !isValid}
          />
        </div>
      </div>
    </Modal>
  );
};

export default RenameClientModal;
